export class Utils{
    //find index of record in recs
    //compares id
    static findIndex(recs,rec) {
		for(var i=0; i<recs.length; i++)
		{
			if(recs[i].id == rec.id)
				return i;
		}
		return -1;
    }
    static findAndUpdateRecord(recs,rec)
    {
        let ind = Utils.findIndex(recs,rec);
        if(ind>=0)
        {
            let _recs = [...recs];
            _recs[ind] = rec;
            return _recs;
        }
        return recs;
    }
    static getSelectedIds(recs)
    {
        var ids=[];
        for(var i=0; i<recs.length; i++)
            ids.push(recs[i].id);
        return ids;
    }
    static dateFromString(str)
    {
        if(str == undefined)
            return new Date();
        if(str.length<10)
            return new Date();
        var yr = parseInt(str.substr(0,4));
        var mn = parseInt(str.substr(5,7));
        var dy = parseInt(str.substr(8,10));

        var dt = new Date();
        dt.setFullYear(yr);
        dt.setMonth(mn);
        dt.setDate(dy);
        return dt;
    }
}

export default Utils;